export default __webpack_public_path__ + "static/media/iceskaters.920ba16b.svg";